const e = (t) => ({
  contentWrapper: {
    position: "relative",
    padding: "0px 24px 24px",
    "@media(max-width: 768px)": {
      padding: "0px 16px 16px"
    }
  },
  title: {
    color: t.palette.common.blue400
  },
  desc: {
    color: t.palette.common.grey200
  },
  listItem: {
    alignItems: "center",
    padding: 0
  },
  textListItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    margin: "12px 0",
    fontSize: t.typography.fontSize16,
    "@media(max-width: 600px)": {
      fontSize: t.typography.fontSize14
    }
  },
  primaryText: {
    color: t.palette.common.grey500,
    lineHeight: 1.4
  },
  secondaryText: {
    color: t.palette.common.grey500,
    lineHeight: 1.4,
    fontWeight: t.typography.fontWeightBold
  }
}), o = e;
export {
  o as default
};
